import { v4 as uuid } from "uuid";

export const videos = [
  {
    _id: uuid(),
    alt: "review-video",
    views: "1.2M",
    duration: "7:38",
    title: "Sony WH-1000XM4 Review: The Final Form!",
    thumbnail:
      "https://i.ytimg.com/vi/bInJjmH31Hk/hq720.jpg?sqp=-oaymwEcCOgCEMoBSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLA_8ZALeLFveUtH_l6LUyohruhuaQ",
    video:
      '<iframe width="560" height="315" src="https://www.youtube.com/embed/bInJjmH31Hk" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>',
  },
  {
    _id: uuid(),
    alt: "review-video",
    views: "1.2M",
    duration: "7:38",
    title: "Sony WH-1000XM4 Review: The Final Form!",
    thumbnail:
      "https://i.ytimg.com/vi/bInJjmH31Hk/hq720.jpg?sqp=-oaymwEcCOgCEMoBSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLA_8ZALeLFveUtH_l6LUyohruhuaQ",
    video:
      '<iframe width="560" height="315" src="https://www.youtube.com/embed/bInJjmH31Hk" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>',
  },
  {
    _id: uuid(),
    alt: "review-video",
    views: "1.2M",
    duration: "7:38",
    title: "Sony WH-1000XM4 Review: The Final Form!",
    thumbnail:
      "https://i.ytimg.com/vi/bInJjmH31Hk/hq720.jpg?sqp=-oaymwEcCOgCEMoBSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLA_8ZALeLFveUtH_l6LUyohruhuaQ",
    video:
      '<iframe width="560" height="315" src="https://www.youtube.com/embed/bInJjmH31Hk" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>',
  },
  {
    _id: uuid(),
    alt: "review-video",
    views: "1.2M",
    duration: "7:38",
    title: "Sony WH-1000XM4 Review: The Final Form!",
    thumbnail:
      "https://i.ytimg.com/vi/bInJjmH31Hk/hq720.jpg?sqp=-oaymwEcCOgCEMoBSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLA_8ZALeLFveUtH_l6LUyohruhuaQ",
    video:
      '<iframe width="560" height="315" src="https://www.youtube.com/embed/bInJjmH31Hk" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>',
  },
  {
    _id: uuid(),
    alt: "review-video",
    views: "1.2M",
    duration: "7:38",
    title: "Sony WH-1000XM4 Review: The Final Form!",
    thumbnail:
      "https://i.ytimg.com/vi/bInJjmH31Hk/hq720.jpg?sqp=-oaymwEcCOgCEMoBSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLA_8ZALeLFveUtH_l6LUyohruhuaQ",
    video:
      '<iframe width="560" height="315" src="https://www.youtube.com/embed/bInJjmH31Hk" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>',
  },
];
